// Line colors for the SOH degradation chart, fixed per entity: String 2 is the
// same color whatever else is selected. Colors come from the entity's level and
// its 1-based position at that level, never from selection order.
//
// No reds in the defaults: a red line reads as a fault on a health chart.
// Org meta can replace any level's palette:
//   batteryHealth.charts.SOHAndRUL.seriesColors = { string: ["#..", ...], battery: "#.." }
const DEFAULT_PALETTE = ["#1F9D8B", "#F2A516", "#2E86DE", "#8E5CC8", "#70C88A", "#6DC8F6"];

export const DEFAULT_SERIES_COLORS = {
    battery: ["#6D72F6"],
    pack: DEFAULT_PALETTE,
    string: DEFAULT_PALETTE,
    module: DEFAULT_PALETTE,
    cell: DEFAULT_PALETTE,
};

const toPalette = (value) => {
    if (typeof value === "string" && value) return [value];
    if (Array.isArray(value)) {
        const colors = value.filter((c) => typeof c === "string" && c);
        if (colors.length) return colors;
    }
    return null;
};

/**
 * @param {{ level?: string, position?: number }} key  position is 1-based within the level
 * @param {Object<string, string|string[]>} [overrides]  org meta seriesColors
 */
export const getSeriesColor = ({ level, position } = {}, overrides) => {
    const levelKey = level?.toLowerCase();
    const palette = toPalette(overrides?.[levelKey])
        || DEFAULT_SERIES_COLORS[levelKey]
        || DEFAULT_PALETTE;
    const index = Number.isInteger(position) && position > 0 ? position - 1 : 0;
    return palette[index % palette.length];
};
